import React from 'react';
import PropTypes from 'prop-types';

const ListIcon = ({ active = false }) => {
    if (!active) {
        return (
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.5 0.5H0.5V6.5H6.5V0.5Z"
                    stroke="black"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.5 9.5H0.5V15.5H6.5V9.5Z"
                    stroke="black"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.5 1.5H15.5"
                    stroke="black"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.5 5.5H15.5"
                    stroke="black"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.5 10.5H15.5"
                    stroke="black"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.5 14.5H15.5"
                    stroke="black"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        );
    }

    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.5 0C0.223858 0 0 0.223858 0 0.5V6.5C0 6.77614 0.223858 7 0.5 7H6.5C6.77614 7 7 6.77614 7 6.5V0.5C7 0.223858 6.77614 0 6.5 0H0.5ZM0.5 9C0.223858 9 0 9.22386 0 9.5V15.5C0 15.7761 0.223858 16 0.5 16H6.5C6.77614 16 7 15.7761 7 15.5V9.5C7 9.22386 6.77614 9 6.5 9H0.5Z"
                fill="#246EFF"
            />
            <path
                d="M9.5 1.5H15.5"
                stroke="#246EFF"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.5 5.5H15.5"
                stroke="#246EFF"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.5 10.5H15.5"
                stroke="#246EFF"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.5 14.5H15.5"
                stroke="#246EFF"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

ListIcon.propTypes = {
    active: PropTypes.bool,
};

export default ListIcon;
